import {Button, Card, CardBody, CardHeader, Typography,} from "@material-tailwind/react";
import React, {useCallback, useContext, useEffect, useMemo, useRef, useState} from "react";
import {getAgentServices} from "../../services/service/service";
import {AgentServiceGrid} from "./agent_service_grid";
import {AgentServiceCheckForm} from "./agent_service_check";
import {AgentServiceDocumentationForm} from "./agent_service_documentation_form";
import {AgentServiceActionForm} from "./agent_service_action_form";
import {ServiceContext} from "../../context/service";
import {ServiceActivities} from "./service_activity";
import {CardFooterPaginator} from "../system/cardFooterPaginator";
import {BsInfoCircle} from "react-icons/bs";
import {AgentServiceStepForm} from "./agent_service_step_form";
import {getServicedSteps} from "../../services/service/service_step";
import {AgentServiceHeaderAlert} from "../alert/service/agent_service_header_alert";
import {PaginateContext} from "../../context/paginate";
import {AgentServiceSideCostForm} from "./agent_service_side_cost_form";
import {getBackOfficeAgentServices} from "../../services/back_office/service";
import AgentServiceShareCalculator from "./agent_service_share_calculator";
import {LoadingOverlay} from "../system/loading_overlay";


export function AgentServiceManagement({person_id}) {

  const {service, setService} = useContext(ServiceContext)
  const [step, setStep] = useState(null);

  const [agentServices, setAgentServices] = useState([]);
  const serviceDetailCacheRef = useRef({});
  const [modalOpen, setModalOpen] = useState(false);
  const [gridRowCount, setGridRowCount] = useState(10);
  const [gridCurrentPage, setGridCurrentPage] = useState(1);
  const [gridSelectedRow, setGridSelectedRow] = useState(null);
  const [documentGridSelectedRow, setDocumentGridGridSelectedRow] = useState(null);
  const [gridTotalRowCount, setGridTotalRowCount] = useState(0);
  const [sortBy, setSortBy] = useState("id")
  const [sortType, setSortType] = useState(false);
  const [from, setFrom] = useState((gridCurrentPage - 1) * gridRowCount + 1);
  const [to, setTo] = useState((gridCurrentPage) * gridRowCount);
  const [lastDataRefresh, setLastDataRefresh] = useState(null);
  const [allAccepted, setAllAccepted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [serviceSteps, setServiceSteps] = useState(null)
  const [serviceStep, setServiceStep] = useState(null)
  const [sideCosts, setSideCosts] = useState([])
  const [sideCost, setSideCost] = useState([])
  const [serviceStepsUpdated, setServiceStepsUpdated] = useState(null)
  const [totalSideCosts, setTotalSideCosts] = useState(0)
  const [totalDays, setTotalDays] = useState(0)
  const [show, setShow] = useState(4)

  const [branchInfo, setBranchInfo] = useState(null)

  const [personId, setPersonId] = useState(person_id)

  const openCheckModal = useCallback((selectedService) => {
    setGridSelectedRow(selectedService);
    setStep("check");
    setModalOpen(true);
  }, []);

  const openReportModal = useCallback((selectedService) => {
    setGridSelectedRow(selectedService);
    setStep("report");
    setModalOpen(true);
  }, []);

  useEffect(() => {
    setPersonId(person_id)
  }, [person_id]);

  useEffect(() => {
    if ((gridCurrentPage) * gridRowCount <= gridTotalRowCount) {
      setTo((gridCurrentPage) * gridRowCount)
    } else {
      setTo(gridTotalRowCount)
    }
    if (gridTotalRowCount === 0) {
      setFrom(0)
    } else {
      setFrom((gridCurrentPage - 1) * gridRowCount + 1)
    }
  }, [gridCurrentPage, gridRowCount, gridTotalRowCount]);

  async function getData(paginate) {
    try {
      setLoading(true);
      let result;
      if (!personId) {
        result = await getAgentServices(paginate);
      } else {
        result = await getBackOfficeAgentServices(paginate, personId);
      }
      if (result.status === 200) {
        const {agentServiceList, total_count} = result.data;
        setAgentServices(agentServiceList || []);
        setGridTotalRowCount(total_count);
      }
    } finally {
      setLoading(false);
    }
  }

  async function getUpdatedServicedSteps() {
    const result = await getServicedSteps(service.id);
    if (result.status === 200) {
      const {service_steps} = result.data;
      setServiceSteps(service_steps || []);


      let total_days = 0;
      if (service_steps && Array.isArray(service_steps)) {
        total_days = service_steps.reduce((sum, step) => sum + (step.days || 0), 0);
      }

      setService(service => ({
        ...service,
        days: total_days,
      }))
      setTotalDays(total_days)

      let total_side_costs = 0;
      if (service_steps && Array.isArray(service_steps)) {
        total_side_costs = service_steps.reduce((sum, step) => sum + (step.side_cost || 0), 0);
      }

      setTotalSideCosts(total_side_costs)

    }
  }

  useEffect(() => {
    const paginate = new URLSearchParams({
      "sort_by": sortBy,
      "sort_type": sortType === false ? "DESC" : "ASC",
      "limit": parseInt(gridRowCount),
      "offset": (parseInt(gridCurrentPage) - 1) * parseInt(gridRowCount),
    }).toString()

    getData(paginate)
  }, [personId, lastDataRefresh, gridCurrentPage, gridRowCount, sortBy, sortType]);

  const serviceContextValue = useMemo(() => ({
    modalOpen,
    setModalOpen,
    gridRowCount,
    setGridRowCount,
    gridCurrentPage,
    setGridCurrentPage,
    service: gridSelectedRow,
    setService: setGridSelectedRow,
    document: documentGridSelectedRow,
    setDocument: setDocumentGridGridSelectedRow,
    lastDataRefresh,
    setLastDataRefresh,
    step,
    setStep,
    allAccepted,
    setAllAccepted,
    from: "agent",
    branchInfo,
    setBranchInfo,
    serviceStep: serviceStep,
    setServiceStep: setServiceStep,
    serviceSteps: serviceSteps,
    setServiceSteps: setServiceSteps,
    serviceStepsUpdated: serviceStepsUpdated,
    setServiceStepsUpdated: setServiceStepsUpdated,
    totalDays: totalDays,
    setTotalDays: setTotalDays,
    totalSideCost: totalSideCosts,
    setTotalSideCosts: setTotalSideCosts,
    services: agentServices,
    setServices: setAgentServices,
    sideCost: sideCost,
    setSideCost: setSideCost,
    sideCosts: sideCosts,
    setSideCosts: setSideCosts,
    show: show,
    setShow: setShow,
    serviceDetailCacheRef,
  }), [
    modalOpen, gridRowCount, gridCurrentPage, gridSelectedRow, documentGridSelectedRow,
    lastDataRefresh, step, allAccepted, branchInfo, serviceStep, serviceSteps, serviceStepsUpdated,
    totalDays, totalSideCosts, agentServices, sideCost, sideCosts, show,
  ]);

  const paginateContextValue = useMemo(() => ({
    setSortBy: setSortBy,
    sortType: sortType,
    setSortType: setSortType,
    active: gridCurrentPage,
    setActive: setGridCurrentPage,
    totalRows: gridTotalRowCount,
    rowsCount: gridRowCount,
    setRowsCount: setGridRowCount,
    from: from,
    to: to,
  }), [sortType, gridCurrentPage, gridTotalRowCount, gridRowCount, from, to]);

  return (
    <ServiceContext.Provider value={serviceContextValue}>
      <PaginateContext.Provider value={paginateContextValue}>
        <div className="flex w-full flex-col gap-4 p-4">
          {step === "check" &&
            <AgentServiceCheckForm/>
          }

          {step === "documentation" &&
            <AgentServiceDocumentationForm/>
          }

          {step === "action" &&
            <AgentServiceActionForm/>
          }
          {step === "report" &&
            <ServiceActivities/>
          }
          {step === "step" &&
            <AgentServiceStepForm/>
          }
          {step === "side_cost" &&
            <AgentServiceSideCostForm/>
          }

          <AgentServiceShareCalculator/>

          <Card className="w-full pt-8">
            <CardHeader floated={true} shadow={false} className="flex flex-col rounded-none">
              <div className="mb-4 flex flex-row justify-between">
                <div className="flex items-center">
                  <Typography variant="h5" color="blue-gray">خدمات من</Typography>
                </div>
                <Button className="flex items-center gap-x-2 py-0 h-12" size="small" variant="outlined" onClick={() => {
                  setStep("guide")
                  setModalOpen(true)
                }}>
                  <BsInfoCircle className="h-5 w-5"/>
                  <Typography className="font-light">
                    راهنما
                  </Typography>
                </Button>
              </div>
              <AgentServiceHeaderAlert/>
            </CardHeader>
          </Card>

          <Card className="w-full">
            <CardBody className="w-full overflow-x-auto p-0">
              {loading && <LoadingOverlay />}
              <div className="relative">
                <AgentServiceGrid
                  services={agentServices}
                  onOpenCheck={openCheckModal}
                  onOpenReport={openReportModal}
                />
              </div>
            </CardBody>
            <CardFooterPaginator/>
          </Card>
        </div>
      </PaginateContext.Provider>
    </ServiceContext.Provider>
  );
}
